<script lang="ts">
  import type { ClientUserStore } from 'shared/src';

  // import uTheory from 'exercises/build/utheory-debug.js';
  import * as Interactives from 'exercises/src/interaction';
  import uInteractiveConfig from 'exercises/src/config';

  import { autorun } from 'mobx';

  import { createEventDispatcher, onDestroy, onMount } from 'svelte';
  import type InteractivePrototype from 'exercises/src/uTheory.Interaction/interactivePrototype';
  import { initializeVexFont } from 'exercises/src/initializeVexFont';
  import type { UPracticeData } from 'shared/definitions/progress-data';
  import { browser } from '$app/env';
  import { errorProvider } from '$lib/error-handling/errorProvider';
  import { pauseUserStoreRefresh, resumeUserStoreRefresh } from '$lib/stores/getUserStore';
  import type { AnswerAndData } from 'shared/definitions/answer-and-data';

  export let clientUserStore: ClientUserStore | undefined;
  export let name: string;
  export let options: any;

  initializeVexFont();

  uInteractiveConfig.apiUrl = import.meta.env.VITE_API_URL;

  let userDataForInteractive: ClientUserStore['userDataForInteractive'] | undefined;
  const destroyer = autorun(() => {
    userDataForInteractive = clientUserStore?.userDataForInteractive;
  });

  let interactiveDiv: HTMLDivElement;

  let interactive: InteractivePrototype;

  // interface $$Events {
  //   gameOver: UPracticeData[];
  //   timeSpent: number;
  //   error: any;
  //   answer: AnswerAndData;
  //   loaded: null;
  // }

  const dispatch = createEventDispatcher<{
    gameOver: UPracticeData[];
    timeSpent: number;
    error: any;
    answer: AnswerAndData;
    loaded: InteractivePrototype;
  }>();

  let startTime = Date.now();
  $: if (browser && interactiveDiv) {
    // if (typeof window === 'undefined' || !interactiveDiv) return;
    if (interactive) {
      interactive.exit();
      dispatch('timeSpent', Date.now() - startTime);
    }

    interactive = new (Interactives as any)[name](interactiveDiv, options, userDataForInteractive);

    interactive.loadingPromise
      .then(() => {
        dispatch('loaded', interactive);
      })
      .catch((err) => {
        errorProvider.error(err);
        dispatch('error', err);
      });

    interactive.addAnswerCallback((data) => {
      dispatch('answer', data);
    });

    interactive.addGameOverCallback((data) => {
      dispatch('gameOver', data);
    });
    startTime = Date.now();
  }

  onMount(pauseUserStoreRefresh);

  onDestroy(() => {
    if (interactive) interactive.exit();
    dispatch('timeSpent', Date.now() - startTime);
    destroyer();
    resumeUserStoreRefresh();
  });
</script>

<div class="u-interactive relative p-4 text-gray-700 font-normal" id="uInteractiveDiv">
  <div style="line-height: initial; text-align: left;" bind:this={interactiveDiv} />
</div>
